import { api } from '../../system/api'

export default {
    getShippingLastmile: params => api.get('shipping-domestic-partners/lastmile', { params }, { singleRequest: true }),
    createLastmileBag: (data) => api.post(`lastmile-bags`, data)
}
